import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0467 = React.lazy(() => import('./symbols/0467_traffic_lights_transport'));
const Symbol0468 = React.lazy(() => import('./symbols/0468_car_transport_vehicle'));
const Symbol0469 = React.lazy(() => import('./symbols/0469_van_truck_transport_vehicle'));
const Symbol0470 = React.lazy(() => import('./symbols/0470_bus_transport'));
const Symbol0471 = React.lazy(() => import('./symbols/0471_train_metro_transport'));
const Symbol0472 = React.lazy(() => import('./symbols/0472_road_trafic'));
const Symbol0473 = React.lazy(() => import('./symbols/0473_ship_naval_sea_marine_transport'));
const Symbol0474 = React.lazy(() => import('./symbols/0474_anchor_ship_sea_naval'));
const Symbol0475 = React.lazy(() => import('./symbols/0475_bike_bycicle_transport'));
const Symbol0476 = React.lazy(() => import('./symbols/0476_chain_link_bike_bycicle'));
const Symbol0477 = React.lazy(() => import('./symbols/0477_steering_wheel_car_navigation_driving'));
const Symbol0478 = React.lazy(() => import('./symbols/0478_plane_air'));
const Symbol0479 = React.lazy(() => import('./symbols/0479_rocket_space_nasa'));
const Symbol0480 = React.lazy(() => import('./symbols/0480_gas_fuel_station'));
const Symbol0481 = React.lazy(() => import('./symbols/0481_corn_traffic_jam_road_sign'));
const Symbol0482 = React.lazy(() => import('./symbols/0482_gauge_dashboard_empty'));
const Symbol0483 = React.lazy(() => import('./symbols/0483_gauge_dashboard_half'));
const Symbol0484 = React.lazy(() => import('./symbols/0484_gauge_dashboard_full_fuel'));
const Symbol0485 = React.lazy(
  () => import('./symbols/0485_gauge_dashboard_speedometer_odometer_speed')
);
const Symbol0486 = React.lazy(
  () => import('./symbols/0486_gauge_car_dashboard_speedometer_odometer_speed')
);
const Symbol0487 = React.lazy(() => import('./symbols/0487_van_truck_transport_vehicle'));
const Symbol0488 = React.lazy(() => import('./symbols/0488_van_truck_transport_vehicle'));
const Symbol0489 = React.lazy(() => import('./symbols/0489_storehouse_storage'));
const Symbol0490 = React.lazy(() => import('./symbols/0490_shipping_cart_box_delivery'));
const Symbol0491 = React.lazy(() => import('./symbols/0491_box_shipping_modules'));
const Symbol0492 = React.lazy(() => import('./symbols/0492_car_wash'));
const Symbol0493 = React.lazy(() => import('./symbols/0493_car_wash'));
const Symbol0494 = React.lazy(() => import('./symbols/0494_4x4_offroad_car_jeep_safari'));
const Symbol0495 = React.lazy(() => import('./symbols/0495_car_garage'));
const Symbol0496 = React.lazy(() => import('./symbols/0496_car_garage_house_home'));
const Symbol0497 = React.lazy(() => import('./symbols/0497_car_machine_piston_cylinder'));
const Symbol0498 = React.lazy(() => import('./symbols/0498_car_battery_electricity'));
const Symbol0499 = React.lazy(() => import('./symbols/0499_car_machine_check'));
const Symbol0500 = React.lazy(() => import('./symbols/0500_car_machine_cooling_water_temperature'));
const Symbol0501 = React.lazy(() => import('./symbols/0501_car_machine_oil_presure_level_check'));
const Symbol0502 = React.lazy(() => import('./symbols/0502_car_brakes_check_safety_danger'));
const Symbol0503 = React.lazy(() => import('./symbols/0503_car_windshield_water'));
const Symbol0504 = React.lazy(() => import('./symbols/0504_car_turn_sign_right_left'));
const Symbol0505 = React.lazy(() => import('./symbols/0505_car_manual_gearbox'));
const Symbol0506 = React.lazy(() => import('./symbols/0506_parking_allowed'));
const Symbol0507 = React.lazy(() => import('./symbols/0507_parking_not_allowed'));
const Symbol0508 = React.lazy(() => import('./symbols/0508_parking_meter'));

export interface IProps {}

const Transportation: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0467_traffic_lights_transport" symbol={<Symbol0467 />} />
      <LazySymbol id="0468_car_transport_vehicle" symbol={<Symbol0468 />} />
      <LazySymbol id="0469_van_truck_transport_vehicle" symbol={<Symbol0469 />} />
      <LazySymbol id="0470_bus_transport" symbol={<Symbol0470 />} />
      <LazySymbol id="0471_train_metro_transport" symbol={<Symbol0471 />} />
      <LazySymbol id="0472_road_trafic" symbol={<Symbol0472 />} />
      <LazySymbol id="0473_ship_naval_sea_marine_transport" symbol={<Symbol0473 />} />
      <LazySymbol id="0474_anchor_ship_sea_naval" symbol={<Symbol0474 />} />
      <LazySymbol id="0475_bike_bycicle_transport" symbol={<Symbol0475 />} />
      <LazySymbol id="0476_chain_link_bike_bycicle" symbol={<Symbol0476 />} />
      <LazySymbol id="0477_steering_wheel_car_navigation_driving" symbol={<Symbol0477 />} />
      <LazySymbol id="0478_plane_air" symbol={<Symbol0478 />} />
      <LazySymbol id="0479_rocket_space_nasa" symbol={<Symbol0479 />} />
      <LazySymbol id="0480_gas_fuel_station" symbol={<Symbol0480 />} />
      <LazySymbol id="0481_corn_traffic_jam_road_sign" symbol={<Symbol0481 />} />
      <LazySymbol id="0482_gauge_dashboard_empty" symbol={<Symbol0482 />} />
      <LazySymbol id="0483_gauge_dashboard_half" symbol={<Symbol0483 />} />
      <LazySymbol id="0484_gauge_dashboard_full_fuel" symbol={<Symbol0484 />} />
      <LazySymbol id="0485_gauge_dashboard_speedometer_odometer_speed" symbol={<Symbol0485 />} />
      <LazySymbol
        id="0486_gauge_car_dashboard_speedometer_odometer_speed"
        symbol={<Symbol0486 />}
      />
      <LazySymbol id="0487_van_truck_transport_vehicle" symbol={<Symbol0487 />} />
      <LazySymbol id="0488_van_truck_transport_vehicle" symbol={<Symbol0488 />} />
      <LazySymbol id="0489_storehouse_storage" symbol={<Symbol0489 />} />
      <LazySymbol id="0490_shipping_cart_box_delivery" symbol={<Symbol0490 />} />
      <LazySymbol id="0491_box_shipping_modules" symbol={<Symbol0491 />} />
      <LazySymbol id="0492_car_wash" symbol={<Symbol0492 />} />
      <LazySymbol id="0493_car_wash" symbol={<Symbol0493 />} />
      <LazySymbol id="0494_4x4_offroad_car_jeep_safari" symbol={<Symbol0494 />} />
      <LazySymbol id="0495_car_garage" symbol={<Symbol0495 />} />
      <LazySymbol id="0496_car_garage_house_home" symbol={<Symbol0496 />} />
      <LazySymbol id="0497_car_machine_piston_cylinder" symbol={<Symbol0497 />} />
      <LazySymbol id="0498_car_battery_electricity" symbol={<Symbol0498 />} />
      <LazySymbol id="0499_car_machine_check" symbol={<Symbol0499 />} />
      <LazySymbol id="0500_car_machine_cooling_water_temperature" symbol={<Symbol0500 />} />
      <LazySymbol id="0501_car_machine_oil_presure_level_check" symbol={<Symbol0501 />} />
      <LazySymbol id="0502_car_brakes_check_safety_danger" symbol={<Symbol0502 />} />
      <LazySymbol id="0503_car_windshield_water" symbol={<Symbol0503 />} />
      <LazySymbol id="0504_car_turn_sign_right_left" symbol={<Symbol0504 />} />
      <LazySymbol id="0505_car_manual_gearbox" symbol={<Symbol0505 />} />
      <LazySymbol id="0506_parking_allowed" symbol={<Symbol0506 />} />
      <LazySymbol id="0507_parking_not_allowed" symbol={<Symbol0507 />} />
      <LazySymbol id="0508_parking_meter" symbol={<Symbol0508 />} />
    </>
  );
});

Transportation.displayName = 'Transportation';

export default Transportation;
